import { GlobalData } from "../Common/GlobalData";
import { ReportDateHelper, TemplateHelpers } from "../Common/KendoHelpers";
import { StockPickList } from "../Common/StockPickList";

export class MovingAverageCrossoverHistory {
    private static readonly GRID = '#grid';

    constructor() {
        this.init();
    }

    private init() {
        const stockPickList = new StockPickList(MovingAverageCrossoverHistory.GRID,
            GlobalData.URL_SUFFIX_TECHNICAL_REPORTS_MOVING_AVERAGE_CROSSOVER_HISTORY);

        $(MovingAverageCrossoverHistory.GRID).kendoGrid({
            dataSource: new kendo.data.DataSource(stockPickList.getDataSourceOptions()),
            height: 915,
            groupable: false,
            sortable: true,
            pageable: false,
            dataBound: () => {
                const data = $(MovingAverageCrossoverHistory.GRID).data('kendoGrid')!.dataSource.data();
                if (!data || data.length == 0) {
                    return;
                }

                ReportDateHelper.showReportDate(data[0].closingDate);
            },
            columns: [{
                field: 'symbol',
                title: 'Symbol',
                width: '5%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'companyName',
                title: 'Company Name',
                width: '19%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                attributes: { 'class': 'table-cell grid-cell-left' },
            }, {
                field: 'fiftyDayNegCrossoverDate',
                title: 'Negative<br>Crossover<br>Date',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('fiftyDayNegCrossoverDate')),
            }, {
                field: 'fiftyDayNegCrossover',
                title: 'Negative<br>Crossover',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n2}',
            }, {
                field: 'fiftyDayNegCrossoverSlope',
                title: 'Negative<br>Crossover<br>Slope',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getColorNumberTemplate('fiftyDayNegCrossoverSlope', 'n2')),
            }, {
                field: 'fiftyDayPosCrossoverDate',
                title: 'Positive<br>Crossover<br>Date',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('fiftyDayPosCrossoverDate')),
            }, {
                field: 'fiftyDayPosCrossover',
                title: 'Positive<br>Crossover',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n2}',
            }, {
                field: 'fiftyDayPosCrossoverSlope',
                title: 'Positive<br>Crossover<br>Slope',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getColorNumberTemplate('fiftyDayPosCrossoverSlope', 'n2')),
            }, {
                field: 'dateDiff',
                title: 'Date<br>Diff',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                //format: '{0:n2}',
            }]
        });
    }
}
